import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import splash from '../Assets/scoreboardsplash.jpg'
import splash_mobile from '../Assets/scoreboardsplash_mobile.jpg'

const mainPage = true;

// --- SECTIONS Data (Hanya Basket) ---
const SECTIONS = [
  {
    title: "Basket",
    items: [
      { label: "Putra SMA", to: "/scoreboard/basket-putra-sma" },
      { label: "Putri SMA", to: "/scoreboard/basket-putri-sma" },
    ],
  },
];

// Button (Pill)
function Pill({ label, to }) {
  return (
    <Link
      to={to}
      className="flex justify-center items-center text-center px-5 py-2 rounded-xl border border-transparent text-sm sm:text-base font-medium"
      style={{
        backgroundColor: "#14CCCC40",
        color: "#1F2A5A",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        minWidth: "8.5rem",
        textDecoration: "none",
      }}
    >
      {label}
    </Link>
  );
}

// Grid that adapts: if one item -> centered; else -> two columns, auto-wrap
function ButtonGrid({ items = [] }) {
  if (items.length <= 1) {
    return (
      <div className="grid place-items-center">
        {items.map((it) => (
          <Pill key={it.label} label={it.label} to={it.to} />
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-4">
      {items.map((it) => (
        <div key={it.label} className="flex justify-center">
          <Pill label={it.label} to={it.to} />
        </div>
      ))}
    </div>
  );
}

// Card
function Card({ title, items }) {
  return (
    // Catatan: Card ini sudah memiliki 'mx-auto' yang membuatnya terpusat di dalam container-nya.
    <div className="rounded-2xl p-8 w-full max-w-[520px] mx-auto" style={{ background: "#FFFFFF", border: "1px solid #DCEAF5" }}>
      <h3
        className="text-center font-semibold text-2xl mb-6"
        style={{ color: "#2B387D" }}
      >
        {title}
      </h3>
      <ButtonGrid items={items} />
    </div>
  );
}

// --- Komponen Utama ScoreboardLayout ---
export default function ScoreboardLayout() {
  return (
    // Background Halaman diubah menjadi biru muda (#E9F6FF)
    <div className="min-h-screen w-full" style={{ background: "#E9F6FF" }}>
      <Navbar />

      {/* --- Splash Image --- */}
      <div className='z-[50px]'>
        <div className='justify-center relative'>
          <div className='z-3 w-full relative'>
            { mainPage && (
              <div>
                <img 
                  src={splash} 
                  className='w-full' 
                  srcSet={`${splash_mobile} 768w, ${splash} 1200w`} 
                  alt="Splash Scoreboard"
                />
              </div>
            )}
          </div>
        </div>
      </div>
      {/* --- Akhir Splash Image --- */}

      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-10 sm:py-12">
        {/*
          PERUBAHAN UTAMA:
          Menghapus grid 2 kolom (`grid-cols-1 md:grid-cols-2`)
          dan menggantinya dengan `flex justify-center` untuk memastikan
          Card Basket berada tepat di tengah horizontal.
        */}
        <div className="flex justify-center">
          {SECTIONS.map((sec) => (
            <Card key={sec.title} title={sec.title} items={sec.items} />
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
}